import { Directive, ElementRef, AfterViewInit, inject } from '@angular/core';

@Directive({ selector: '[PlateNumber]', standalone: true })
export class PlateNumberDirective implements AfterViewInit {
  element = inject(ElementRef);

  public el: ElementRef;
  constructor() {
    const element = this.element;

    this.el = element;
  }

  ngAfterViewInit() {
    if (this.el.nativeElement.innerHTML.length === 6) {
      const firstHalf = this.el.nativeElement.innerHTML.slice(0, 3);
      const otherHalt = this.el.nativeElement.innerHTML.slice(3, 6);
      this.el.nativeElement.innerHTML = firstHalf + '-' + otherHalt;
    }
  }
}
